<template>
  <div v-if="canBeShown">
    <div class="columns">
      <div class="column is-2" v-for="l in dataLegendeGeoMarketting" :key="l.index">
        <b-icon icon="circle" :style="{ color: l.color }"/>
        {{ l.text }}
      </div>
    </div>
    <div class="columns">
      <div class="column is-7">
        <b-table :data="dataTableGeoMarketting" :columns="columnTableGeoMarketting"></b-table>
      </div>
      <div class="column is-5">
        <img :src="urlChart" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { getChartUrl } from '@/services/asterop/getUrl';
import { getDataTable, getMapMetadata, getMapData } from '@/api/asterop';
import { TYPE_LAYER_EMPTY, TYPE_LAYER_GEO_MARKETING_CONCU } from '@/configuration/carteConf';

const User = createNamespacedHelpers('user');

export default {
  name: 'statistiques-geo-marketing',
  props: ['address', 'isochrone', 'typeLayerGeoMarketing'],
  data() {
    return {
      dataTableGeoMarketting: [],
      columnTableGeoMarketting: [],
      dataLegendeGeoMarketting: [],
    };
  },
  computed: {
    ...User.mapGetters({
      hasGeoMarketing: 'hasGeoMarketing',
    }),
    canBeShown() {
      return this.hasGeoMarketing &&
        this.typeLayerGeoMarketing !== TYPE_LAYER_EMPTY &&
        this.typeLayerGeoMarketing !== TYPE_LAYER_GEO_MARKETING_CONCU;
    },
    urlChart() {
      if (!this.address) {
        return '';
      }
      return getChartUrl(this.typeLayerGeoMarketing, this.address, this.isochrone);
    },
  },
  watch: {
    async isochrone() {
      await this.updateAll();
    },
    async address() {
      await this.updateAll();
    },
    async typeLayerGeoMarketing() {
      await this.updateAll();
    },
  },
  async mounted() {
    await this.updateAll();
  },
  methods: {
    async updateAll() {
      if (!this.canBeShown) {
        this.dataTableGeoMarketting = [];
        this.columnTableGeoMarketting = [];
        this.dataLegendeGeoMarketting = [];
        return;
      }
      await this.updateDataTable();
      await this.updateLegende();
    },
    async updateDataTable() {
      this.dataTableGeoMarketting = [];
      this.columnTableGeoMarketting = [];
      if (!this.address) {
        return;
      }
      const response = await getDataTable(this.typeLayerGeoMarketing, this.address, this.isochrone);
      this.columnTableGeoMarketting = response.data.columnHeaders.items.map((item, index) => {
        return {
          field: 'c' + index,
          label: item.name,
        };
      });
      this.dataTableGeoMarketting = response.data.items.map((item, index) => {
        const data = {
          cat: response.data.rowHeaders.items[index].name,
        };
        response.data.columnHeaders.items.forEach((element, colindex) => {
          data['c' + colindex] = item[colindex].text;
        });
        return data;
      });
      this.columnTableGeoMarketting.unshift({
        field: 'cat',
        label: '',
      });
    },
    async updateLegende() {
      this.dataLegendeGeoMarketting = [];
      if (!this.address) {
        return;
      }
      const responseMetadata = await getMapMetadata(
        this.typeLayerGeoMarketing, this.address, this.isochrone);
      const responseData = await getMapData(
        this.typeLayerGeoMarketing, this.address, this.isochrone, 0);
      this.dataLegendeGeoMarketting = responseMetadata.data.layers[0].layer.properties
        .fillColor.thematic.classes.map((item, index) => {
          const values = responseData.data.legend.fillColor.thematic.classes[index];
          ['<TKLB>', '<TKUB>'].forEach(element => {
            item.pattern = item.pattern.replace(element, values[element].text);
          });
          let color = item.value.toString(16).padStart(6, '0');
          color = '#' + color.substring(4, 6) + color.substring(2, 4) + color.substring(0, 2);
          return {
            index,
            text: item.pattern,
            oldColor: item.value.toString(16),
            color,
          };
        });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/general/statistiquesGeoMarketing.vue